<div class="note-alert" [id]="containerId">
    <div class="note-alert__icon-box">
        <icon name="lightbulb"></icon>
    </div>
    <div class="p-3" [innerHTML]="message" *ngIf="message">
    </div>
    <ng-content></ng-content>
</div>